import {
  Container,
  StyledElementContainer,
  CaptionContainer,
} from "./index.styled";

export default function ElementContainer(props) {
  return (
    <Container>
      {props.caption && (
        <CaptionContainer>
          <label>{props.caption}</label>
        </CaptionContainer>
      )}
      <StyledElementContainer display={props.display}>
        {props.children}
      </StyledElementContainer>
    </Container>
  );
}
